module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHklEQVQImWOUEFH9zwAFjE+WFcE5LFdO3oOwGBgYAJBcBs1nm+dqAAAAAElFTkSuQmCC"